module.exports = __webpack_public_path__ + "images/花筑院子全景_04-4.jpg?v=d4883b95";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu4/花筑院子全景_04-4.jpg
 ** module id = 75
 ** module chunks = 1 2
 **/